import debounce from "lodash/debounce";

export const useDebouncedSearch = (
  setValue,
  setSearchLoad,
  setSearchResult,
  setRecentSearch,
  setResType,
  listingURL,
  filterActiveListings,
  filterListingsWithPhotos,
  getSearchLocation,
  type
) => {
  const debouncedSearch = debounce(async (event) => {
    const currentSearchTerm = event.target.value;
    try {
      let query = "";

      setSearchLoad(true);

      if (currentSearchTerm.includes(",")) {
        const q = currentSearchTerm.split(",").join(" ");
        query = q;
      } else {
        query = currentSearchTerm;
      }

      let url = "residential/merge_listings?";

      if (type === "rent") url = "rental/merge_listings?";

      if (query) url += `q=${query}&limit=40`;
      else url += "limit=40";

      const { data: res } = await listingURL.get(url);
      // const activeListings = filterActiveListings(res?.data);
      // const results = filterListingsWithPhotos(activeListings);
      const results = res?.data;

      results?.length === 0
        ? getSearchLocation(currentSearchTerm)
        : localStorage.removeItem("places");

      setSearchResult(results);
      setRecentSearch(res?.resent_search?.reverse());
      setResType(res?.name);
    } catch (error) {
      console.error("Search request failed:", error);
    } finally {
      setSearchLoad(false);
    }
  }, 500);

  const onSearchHandler = (event) => {
    if (!event.target.value) {
      setValue("");
      setSearchResult();
    } else {
      setValue(event.target.value);
      debouncedSearch(event);
    }
  };

  return onSearchHandler;
};
